/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigurationModel } from '../../models/configuration-model';

export interface AdminFhirIdConfigurationGet$Params {
  fhirId: string;
}

export function adminFhirIdConfigurationGet(http: HttpClient, rootUrl: string, params: AdminFhirIdConfigurationGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<ConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdConfigurationGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<ConfigurationModel>;
    })
  );
}

adminFhirIdConfigurationGet.PATH = '/Admin/{fhirId}/Configuration';
